import React from "react";
import Dashboard from "../components/Dashboard";

function AdminHome() {
  return (
    <div>
      <Dashboard />
    </div>
  );
}

export default AdminHome;
